import React from 'react'
import { Button } from 'hljd'
import { hashHistory } from 'react-router'
import { HOME_PATH } from '@constant'

export default () => (
  <div className="center text-center">
    <h2>找不到页面啦</h2>
    <Button type="primary" onClick={() => hashHistory.push(HOME_PATH)}>
      回到首页
    </Button>
  </div>
)
